import { MULTI_TAB_SYNC_STORAGE_KEY } from 'constants/common';
import { IS_FIRST_TIME_KEY } from 'constants/patientList';

export const STORAGE_KEYS = {
  EMAIL: 'email',
  JUST_LOGGED_IN: 'justLoggedIn',
  STREAM_ID: 'streamId',
  CHAT_TOKEN: 'chatToken',
  SYNC_TABS: MULTI_TAB_SYNC_STORAGE_KEY,
  FIRST_TIME_TO_PATIENT_PAGE: IS_FIRST_TIME_KEY,
  SOA_PERIOD: 'soaPeriod',
  SOA_CLINIC: 'soaClinic',
  REVENUE_CLINIC: 'revenueClinic',
  REVENUE_FILTERS: 'revenueFilters'
} as const;

const LOCAL_STORAGE_KEYS_TO_REMOVE_ON_LOGOUT = [
  STORAGE_KEYS.JUST_LOGGED_IN,
  STORAGE_KEYS.STREAM_ID,
  STORAGE_KEYS.CHAT_TOKEN
] as const;

export const getSessionStorageItem = (key: string): string | null =>
  sessionStorage.getItem(key);

export const setSessionStorageItem = (key: string, value: string): void => {
  sessionStorage.setItem(key, value);
  localStorage.removeItem(key);
};

export const removeSessionStorageItem = (key: string): void => {
  sessionStorage.removeItem(key);
  localStorage.removeItem(key);
};

export const removeLegacySessionKeysFromLocalStorage = (): void => {
  localStorage.removeItem(STORAGE_KEYS.JUST_LOGGED_IN);
  localStorage.removeItem(STORAGE_KEYS.STREAM_ID);
};

const SEGMENT_COOKIE_KEYS = [
  'ajs_anonymous_id',
  'ajs_user_id',
  'ajs_group_id'
] as const;

/** Removes Segment cookies / localStorage left from before disableClientPersistence. */
export const clearSegmentClientPersistence = (): void => {
  SEGMENT_COOKIE_KEYS.forEach((name) => {
    document.cookie = `${name}=; Max-Age=0; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`;
  });

  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith('ajs_') || key.startsWith('segment'))
      .forEach((key) => localStorage.removeItem(key));
  } catch {
    // ignore quota / private-mode access errors
  }
};

/**
 * Resets Segment when a previous user is still identified in this browser, so the
 * next user's events don't carry that user's userId / anonymousId (which makes
 * MoEngage merge the two profiles). Call it inside analytics.ready.
 */
export const resetPreviousSegmentUser = (nextUserId?: string): void => {
  const previousUserId = window.analytics?.user?.()?.id?.();
  if (previousUserId && previousUserId !== nextUserId) {
    window.analytics.reset();
  }
};

export const clearUserBrowserStorage = (): void => {
  LOCAL_STORAGE_KEYS_TO_REMOVE_ON_LOGOUT.forEach((key) => {
    localStorage.removeItem(key);
  });
  clearSegmentClientPersistence();
  sessionStorage.clear();
};
